import React from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import { Tables, Sofa, Href, Chairs } from "../../../../Constants/Constants";
import { SimpleNavProps } from "../../../../Types/UiKitsType";

const BackgroundPillNav: React.FC<SimpleNavProps> = ({ basicTab, setBasicTab }) => {
  return (
    <Nav pills className="nav-primary mb-0 justify-content-end" id="pills-bg-tab">
      <NavItem>
        <NavLink href={Href} className={`tab-primary ${basicTab === "1" ? "active" : ""}`} onClick={() => setBasicTab("1")}>{Sofa}</NavLink>
      </NavItem>
      <NavItem>
        <NavLink href={Href} className={`tab-primary ${basicTab === "2" ? "active" : ""}`} onClick={() => setBasicTab("2")}>{Chairs}</NavLink>
      </NavItem>
      <NavItem>
        <NavLink href={Href} className={`tab-primary ${basicTab === "3" ? "active" : ""}`} onClick={() => setBasicTab("3")}>{Tables}</NavLink>
      </NavItem>
    </Nav>
  );
};
export default BackgroundPillNav;
